import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import Home from "./assests/pages/home/home.jsx";
import Contact from "./assests/pages/contact/contact.jsx";
import TermsAndConditions from "./assests/pages/terms-and-conditions/terms-and-conditions.jsx";
import Assembly from "./assests/pages/furniture-assembly.jsx";
import TVMounting from "./assests/pages/tv-mounting.jsx";
import Installation from "./assests/pages/installations.jsx";
import Carpentry from "./assests/pages/carpentry.jsx";
import PlasteringPainting from "./assests/pages/plastering-painting.jsx";
import HomeMaintenance from "./assests/pages/home-maintenance.jsx";
import Gardening from "./assests/pages/gardening.jsx";
import NotFoundPage from "./assests/pages/not-found-page/not-found-page.jsx";
import CommercialMaintenance from "./assests/pages/commercial-maintenance.jsx";
import Footer from "./assests/components/footer/footer.jsx";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/furniture-assembly" element={<Assembly />} />
          <Route path="/tv-mounting-wall-art" element={<TVMounting />} />
          <Route path="/installations" element={<Installation />} />
          <Route path="/carpentry" element={<Carpentry />} />
          <Route path="/plastering-painting" element={<PlasteringPainting />} />
          <Route path="/home-maintenance" element={<HomeMaintenance />} />
          <Route path="/commercial-maintenance" element={<CommercialMaintenance />} />
          <Route path="/gardening" element={<Gardening />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
      </Router>
    </HelmetProvider>
  );
}

export default App;
